/* eslint-disable no-unused-vars */
import { useEffect, useState, useMemo } from 'react';
import { useParams, useLocation, Outlet } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useBee } from 'contexts/Bee';
import { useFetch } from 'use-http';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
//import { useForm, FormProvider } from 'react-hook-form';
import { TableProvider, useTableProvider } from 'contexts/TableProvider';
import { QuickViewCore } from 'contexts/QuickViewProvider';
import moment from 'moment';

//component
import PageHeader from 'components/PageHeader';

//project import
import { openSnackbar, closeSnackbar } from 'store/reducers/snackbar';

//MUI
import
{
   Box,
   Divider,
   Skeleton,
   Tab,
   Tabs,
   Typography
} from '@mui/material'

import { LoadingButton } from '@mui/lab';

//FA Icons
import
{
   faTrash,
   faFloppyDisk,
   faCalendar,
   faUserGroup,
   faCoins,
   faBriefcase,
   faPaperclip
} from '@fortawesome/pro-regular-svg-icons';

const MainServizioMarkup = () =>
{
   //recupero id operatore dai parametri url
   const {
      idContratto,
      idServizio
   } = useParams();

   //recupero i dati di paginazione e filtraggio dal context
   const {
      loading,
      error,
      data
   } = useTableProvider();

   const {
      pageTitle,
      setPageTitle,
      pageSubtitle,
      setPageSubtitle,
      breadcrumbs,
      setBreadcrumbs
   } = useBee();

   console.log('DATA', data);

   //recupero l'oggetto location
   const { pathname } = useLocation();

   //inizializzo hook dispatch
   const dispatch = useDispatch()

   const {
      request,
   } = useFetch(process.env.REACT_APP_BASE_API_URL, { cachePolicy: 'no-cache' });

   //imposto l'oggetto con i links pre la breadcrumbs
   const breadcrumbDefault = useMemo(() =>
   {
      return [
         {
            label: "Pianificazione",
         },
         {
            label: "Contratti",
            path: "/pianificazione/contratti"
         },
         {
            label: `Contratto #${idContratto}`,
            path: `/pianificazione/contratti/${idContratto}/servizi/`
         },
         {
            label: "Assegnazione risorse"
         }
      ];
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [data, loading]);

   //inizializzo gli status
   const [tab, setTab] = useState(0);
   const [success, setSuccess] = useState(null);

   useEffect(() =>
   {
      if (data)
      {
         setPageTitle(data?.contratto?.titolo);
         setPageSubtitle(` - dal ${moment(moment(data?.dal).toDate()).format('DD/MM/YYYY')} al ${moment(moment(data?.al).toDate()).format('DD/MM/YYYY')}`);
         setBreadcrumbs(breadcrumbDefault);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [data]);

   useEffect(() =>
   {
      switch (true)
      {
         case /\/pianificazione\/contratti\/([0-9]*)\/servizi\/([0-9]*)\/assegnazione-risorse/g.test(pathname):
            setTab(0);
            break;
         case /\/pianificazione\/contratti\/([0-9]*)\/servizi\/([0-9]*)\/operatori-assegnati/g.test(pathname):
            setTab(1);
            break;
         case /\/pianificazione\/contratti\/([0-9]*)\/servizi\/([0-9]*)\/costi/g.test(pathname):
            setTab(2);
            break;
         case /\/pianificazione\/contratti\/([0-9]*)\/servizi\/([0-9]*)\/dotazioni/g.test(pathname):
            setTab(3);
            break;
         case /\/pianificazione\/contratti\/([0-9]*)\/servizi\/([0-9]*)\/note-ed-allegati/g.test(pathname):
            setTab(4);
            break;
         default:
            setTab(0);
      }
   }, [pathname]);

   //gestione tab attivo
   const handleTab = (event, newValue) =>
   {
      setTab(newValue);
   };

   //gestisco gli alerts
   useEffect(() =>
   {
      closeSnackbar();

      if (success)
      {
         dispatch(
            openSnackbar({
               anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'center',
               },
               open: true,
               message: "Modifiche salvate correttamente",
               variant: 'alert',
               alert: {
                  color: 'success'
               },
               close: false
            })
         );

         setSuccess(null);
      } else if (error)
      {
         dispatch(
            openSnackbar({
               anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'center',
               },
               open: true,
               message: `Si è verificato un errore (${error?.message})`,
               variant: 'alert',
               alert: {
                  color: 'error'
               },
               close: false
            })
         );
      }

      return () =>
      {
         closeSnackbar();
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [success, error]);

   const StyledTab = styled(Tab)(() => ({
      lineHeight: 1
   }));

   return (
      <>
         <PageHeader
            title={
               loading ? <Skeleton width={150} /> : pageTitle
            }
            breadcrumbs={breadcrumbs}
            afterTitle={loading ? <Skeleton width={230} /> : (
               <Typography
                  variant="body"
               >
                  <Typography
                     component="span"
                     variant="body"
                     sx={{
                        color: 'text.secondary',
                        fontWeight: 700
                     }}
                  >
                     {data?.contratto?.cliente?.ragione_sociale.replace(/"/g, '')}
                  </Typography>

                  {pageSubtitle}

               </Typography>
            )}
            sx={{
               marginBottom: '.25rem'
            }}
         />
         <Box
            sx={{
               mb: 1.5
            }}
         >
            <Tabs
               value={tab}
               onChange={handleTab}
               variant="scrollable"
               scrollButtons="auto"
               allowScrollButtonsMobile
               aria-label="Contratto">
               <StyledTab
                  component={RouterLink}
                  label="Servizio"
                  to={`/pianificazione/contratti/${idContratto}/servizi/${idServizio}/assegnazione-risorse`}
                  icon={<FontAwesomeIcon icon={faCalendar} />}
                  iconPosition="start"
               />
               <StyledTab
                  component={RouterLink}
                  label="Operatori assegnati"
                  to={`/pianificazione/contratti/${idContratto}/servizi/${idServizio}/operatori-assegnati`}
                  icon={<FontAwesomeIcon icon={faUserGroup} />}
                  iconPosition="start"
               />
               <StyledTab
                  component={RouterLink}
                  label="Costi"
                  to={`/pianificazione/contratti/${idContratto}/servizi/${idServizio}/costi`}
                  icon={<FontAwesomeIcon icon={faCoins} />}
                  iconPosition="start"
               />
               <StyledTab
                  component={RouterLink}
                  label="Dotazioni"
                  to={`/pianificazione/contratti/${idContratto}/servizi/${idServizio}/dotazioni`}
                  icon={<FontAwesomeIcon icon={faBriefcase} />}
                  iconPosition="start"
               />
               <StyledTab
                  component={RouterLink}
                  label="Note ed Allegati"
                  to={`/pianificazione/contratti/${idContratto}/servizi/${idServizio}/note-ed-allegati`}
                  icon={<FontAwesomeIcon icon={faPaperclip} />}
                  iconPosition="start"
               />
            </Tabs>
            <Divider
               sx={{
                  borderColor: '#eee'
               }}
            />
         </Box>
         <Box>
            <Outlet />
         </Box>
      </>
   )
}

const MainServizio = () =>
{

   //recupero id operatore dai parametri url
   const {
      idContratto,
      idServizio
   } = useParams();

   return (
      <TableProvider path={`/api/pianificazione/contratti/${idContratto}/servizi/${idServizio}/`}>
         <QuickViewCore>
            <MainServizioMarkup />
         </QuickViewCore>
      </TableProvider>
   )
}

export default MainServizio;